<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-size-100">
        <EditarPedido data-background-color="green"></EditarPedido>
      </div>
    </div>
  </div>
</template>

<script>
import EditarPedido from "../components/Pedido/EditarPedido.vue";

export default {
  components: {
    EditarPedido
  }
};
</script>
